import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Store } from '@ngrx/store';

import { BuyerService } from '../../../core/api/buyer.service';
import * as fromApp from '../../../store';
import { DocusignTemplate } from '../../models/docusign-template.model';

export interface DialogData {
  buyerId: number;
}

@Component({
  selector: 'fc-dialog-send-edoc',
  templateUrl: './dialog-send-edoc.component.html',
  styleUrls: ['./dialog-send-edoc.component.scss'],
})
export class DialogSendEdocComponent implements OnInit {
  selectEdocTemplateForm: UntypedFormGroup;
  currentBuyerId: number;
  templates: DocusignTemplate[];

  constructor(
    public dialogRef: MatDialogRef<DialogSendEdocComponent>,
    private formBuilder: UntypedFormBuilder,
    readonly buyerService: BuyerService,
    readonly store: Store<fromApp.AppState>,
    public snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    this.currentBuyerId = data.buyerId;
  }

  ngOnInit() {
    this.selectEdocTemplateForm = this.formBuilder.group({
      templateId: ['', Validators.required],
    });
    this.buyerService.getEdocTemplates(`?buyer_id=${this.currentBuyerId}`).subscribe((response: any) => {
      this.templates = response;
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  onSubmit() {
    this.dialogRef.close(this.selectEdocTemplateForm.value.templateId);
  }
}
